/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditInfolet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2H2v20h7.998L10 21l-.003-1H4V8h16v2.692c.04.06.08.121.12.187l1.88 1.88zM9.998 16.757 12 14.755V10H6v8h2.573zm5.879-5.878A4.415 4.415 0 0 1 17.113 10H14v2h.755zM4 6V4h16v2zm4 6h2v4H8zm10.705.293a1 1 0 0 0-1.414 0l-5.293 5.293V22h4.414l5.293-5.293a1 1 0 0 0 0-1.414zM13.998 20v-1.586l4-4L19.584 16l-4 4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEditInfolet as EditInfolet };
